import React from 'react';
import { useTitle } from 'react-use';
import { Button, Grid, Header, Image, Container } from 'semantic-ui-react';
import { Element, Link } from 'react-scroll';
import { useSelector } from 'react-redux';
import Inbox from './inbox/Inbox';
import Source from '../../../assets/surveillance.svg';
import Footer from '../../shared-components/Footer';
import Navbar from '../../shared-components/Navbar';

function Maintenance() {
	useTitle('Laboratory | Mosquito Surveillance Identification');

	return (
		<>
			<Navbar />
			<Grid stackable verticalAlign="middle" padded="vertically">
				<Grid.Row columns={1} color="blue" style={{ minHeight: 400 }}>
					<Grid.Column>
						<Grid
							container
							stackable
							style={{ paddingTop: 80, paddingBottom: 80 }}
						>
							<Grid.Row columns={2} verticalAlign="middle">
								<Grid.Column>
									<Image centered src={Source} height={200} />
								</Grid.Column>
								<Grid.Column>
									<Header as="h1" inverted>
										Mosquito Surveillance Identification
									</Header>
									<p className="quiet">
										The following survey it&apos;s intended to collect mosquito
										occurrence data from AGO and OVI traps deployed in a
										surveillance system
									</p>
									<Button
										primary
										size="mini"
										content="Collect Now!!"
										as={Link}
										to="segment"
										smooth
										duration={500}
										spy
									/>
								</Grid.Column>
							</Grid.Row>
						</Grid>
					</Grid.Column>
				</Grid.Row>
				<Grid.Row columns={1} as={Element} name="segment">
					<Grid.Column>
						<Container text>
							<Grid stackable padded="vertically">
								<Grid.Row columns={1}>
									<Grid.Column>
										<Header as="h2">
											{useSelector(state => state.inbox.positive)}
										</Header>
										<p className="small quiet">
											This table shows all the traps that were service from the
											PRVCU Field Team. Please verify the Date, Trap ID, Trap
											Status and comments before entering mosquito data
										</p>
									</Grid.Column>
								</Grid.Row>
								<Inbox />
							</Grid>
						</Container>
					</Grid.Column>
				</Grid.Row>
			</Grid>
			<Footer />
		</>
	);
}

export default Maintenance;
